import styled from '@emotion/styled'
import { Paper } from '@material-ui/core'
import { MdCancel } from 'react-icons/md'



export const MainContainer = styled.div`
  max-width: ${({ width }) => width || `400px`};
  min-width: 320px;
  width: 40vw;
  position: absolute;
  background-color: transparent;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  font-family: sans-serif;
`

export const HeaderContainer = styled.div`
  display: flex;
  height: 40px;
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  color: white;
  align-items: center;
  background-color: transparent;
`

export const HeaderCloseButton = styled.div`
  margin-left: auto;
  cursor: pointer;
  display: flex;
  justify-content: center;
`

export const HeaderCloseIcon = styled(MdCancel)`
  color: white;
`

export const ContentBody = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  box-shadow: none;
  padding: 20px 20px 10px;
`
